module.exports = __webpack_public_path__ + "static/media/CRS_Logo.5edc4411.svg";